export default {
  summary: {
    delivery: 'Envío: Tarjeta regalo en PDF por correo electrónico',
  },
};
